import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3"
}
const _hoisted_2 = { class: "table table-striped border-light" }
const _hoisted_3 = { colspan: "2" }
const _hoisted_4 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "table table-striped border-light" }
const _hoisted_16 = { colspan: "2" }
const _hoisted_17 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = {
  key: 0,
  class: "text-secondary ms-2"
}
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "table table-striped border-light" }
const _hoisted_26 = { colspan: "2" }
const _hoisted_27 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_28 = { class: "text-capitalize-first" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { class: "text-capitalize-first" }
const _hoisted_31 = { class: "text-capitalize-first" }
const _hoisted_32 = {
  key: 0,
  class: "text-secondary ms-2"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "text-capitalize-first" }
const _hoisted_35 = {
  key: 0,
  class: "text-secondary ms-2"
}
const _hoisted_36 = { class: "text-capitalize-first" }
const _hoisted_37 = { class: "text-capitalize-first" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["href"]
const _hoisted_40 = { key: 4 }
const _hoisted_41 = { class: "table table-striped border-light" }
const _hoisted_42 = { colspan: "2" }
const _hoisted_43 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = {
  key: 3,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_46 = {
  class: "d-flex",
  style: {"clear":"both"}
}
const _hoisted_47 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_InvoiceDealDetailsTable = _resolveComponent("InvoiceDealDetailsTable")!
  const _component_InvoiceDetailsTable = _resolveComponent("InvoiceDetailsTable")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_TradeDealDetailsTable = _resolveComponent("TradeDealDetailsTable")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      (_ctx.operation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, [
                    _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.operation')), 1)
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(_ctx.operation.id) + " ", 1),
                    _createVNode(_component_copy_button, {
                      value: _ctx.operation.id
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(_ctx.operation.createdAt)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`operation_type.${_ctx.operation.operationType}`)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass({'text-success': _ctx.operation.transactionType === _ctx.TransactionType.CREDIT, 'text-danger': _ctx.operation.transactionType !== _ctx.TransactionType.CREDIT})
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.operation.transactionType === _ctx.TransactionType.CREDIT ? "+" : '-') + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.operation.sum)) + " ", 1),
                      _createVNode(_component_copy_button, {
                        value: _ctx.numberFormatter.formatNumber(_ctx.operation.sum)
                      }, null, 8, ["value"])
                    ], 2)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.balance_before')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.operation.balanceBefore)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.balance_after')), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.operation.balanceAfter)), 1)
                ])
              ])
            ]),
            (_ctx.invoiceDeal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.invoice_deal')), 1),
                  _createVNode(_component_InvoiceDealDetailsTable, {
                    deals: [_ctx.invoiceDeal]
                  }, null, 8, ["deals"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.invoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_InvoiceDetailsTable, { invoice: _ctx.invoice }, null, 8, ["invoice"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.deposit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("table", _hoisted_15, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_16, [
                          _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.deposit_tx')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deposit.sum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deposit.sum.amount
                          }, null, 8, ["value"]),
                          (_ctx.deposit.creditedSum.currency !== _ctx.deposit.sum.currency)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_19, [
                                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.deposit.creditedSum)) + " ", 1),
                                _createVNode(_component_copy_button, {
                                  value: _ctx.deposit.creditedSum.amount
                                }, null, 8, ["value"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.address.usdt')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.deposit.walletAddress) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deposit.walletAddress
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.from_address.usdt')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.deposit.fromAddress) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deposit.fromAddress
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.tx_id')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.deposit.txId.substring(0, 16)) + "... ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.deposit.txId
                          }, null, 8, ["value"]),
                          _createElementVNode("a", {
                            href: `https://tronscan.org/#/transaction/${_ctx.deposit.txId}`,
                            target: "_blank",
                            class: "ms-2"
                          }, _cache[0] || (_cache[0] = [
                            _createElementVNode("i", { class: "fa fa-external-link" }, null, -1)
                          ]), 8, _hoisted_23)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.withdrawal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("table", _hoisted_25, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_26, [
                          _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.withdraw_order')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.withdrawal.id) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.withdrawal.id
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('labels.date')), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(_ctx.withdrawal.createdAt)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`withdrawal_status.${_ctx.withdrawal.status}`)), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.helper.trans('labels.sum')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.withdrawal.sum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.withdrawal.sum.amount
                          }, null, 8, ["value"]),
                          (_ctx.withdrawal.debitedSum.currency !== _ctx.withdrawal.sum.currency)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_32, [
                                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.withdrawal.debitedSum)) + " ", 1),
                                _createVNode(_component_copy_button, {
                                  value: _ctx.withdrawal.debitedSum.amount
                                }, null, 8, ["value"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.withdrawal.fee)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                            _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.withdrawal.fee)) + " ", 1),
                              _createVNode(_component_copy_button, {
                                value: _ctx.withdrawal.fee.amount
                              }, null, 8, ["value"]),
                              (_ctx.withdrawal.debitedFee.currency !== _ctx.withdrawal.fee.currency)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_35, [
                                    _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.withdrawal.debitedFee)) + " ", 1),
                                    _createVNode(_component_copy_button, {
                                      value: _ctx.withdrawal.debitedFee.amount
                                    }, null, 8, ["value"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.address.usdt')), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(_ctx.withdrawal.address) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.withdrawal.address
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.helper.trans('labels.tx_id')), 1),
                        _createElementVNode("td", null, [
                          (_ctx.withdrawal.txId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createTextVNode(_toDisplayString(_ctx.withdrawal.txId.substring(0, 16)) + "... ", 1),
                                _createVNode(_component_copy_button, {
                                  value: _ctx.withdrawal.txId
                                }, null, 8, ["value"]),
                                _createElementVNode("a", {
                                  href: `https://tronscan.org/#/transaction/${_ctx.withdrawal.txId}`,
                                  target: "_blank",
                                  class: "ms-2"
                                }, _cache[1] || (_cache[1] = [
                                  _createElementVNode("i", { class: "fa fa-external-link" }, null, -1)
                                ]), 8, _hoisted_39)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.linkedAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("table", _hoisted_41, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_42, [
                          _createElementVNode("h5", _hoisted_43, _toDisplayString(_ctx.helper.trans(`operation_type.${_ctx.operation.operationType}`)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.operation.transactionType === _ctx.TransactionType.DEBIT ? _ctx.helper.trans('labels.to_account') : _ctx.helper.trans('labels.from_account')), 1),
                        _createElementVNode("td", null, [
                          (_ctx.linkedSystemAccount)
                            ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                key: 0,
                                "show-badge": "",
                                user: _ctx.systemUser
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true),
                          (_ctx.linkedTraderAccount)
                            ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                key: 1,
                                "show-badge": "",
                                user: _ctx.linkedTraderAccount.user
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true),
                          (_ctx.linkedUserAccount)
                            ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                key: 2,
                                "show-badge": "",
                                user: _ctx.linkedUserAccount.user
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true),
                          (_ctx.linkedMerchantStoreAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_UserNameLabel, {
                                    "show-badge": "",
                                    user: _ctx.linkedMerchantStoreAccount.user
                                  }, null, 8, ["user"]),
                                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.linkedMerchantStoreAccount?.storeName), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.deal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createVNode(_component_TradeDealDetailsTable, { deal: _ctx.deal }, null, 8, ["deal"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}